<template>
    <div class="client-slider">
        <carousel :breakpoints="breakpoints" :items-to-show="4" :wrapAround="true" :autoplay="10000" snapAlign="start">

            <slide v-for="(slide, i) in items" :key="i" class="client-slide-item">
                <div class="client-slide-item-inner">
                    <img class="transition-3s" :src="slide" alt="Client">
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';

export default {
    name: 'ClientSlider',
    props: ['items'],
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            breakpoints: {
                1024: {
                    itemsToShow: 4
                },
                768: {
                    itemsToShow: 3
                },
                570: {
                    itemsToShow: 2
                },
                0: {
                    itemsToShow: 1
                }
            }
        }
    }
}
</script>